import { baseService, GLOBAL_TAG_TYPES } from '@repo/services';
import { transformGraphqlResponse } from '@repo/utils';
import { getCriteria } from 'crm-atoms/queries/getCriteria';

const criteriaService = baseService.injectEndpoints({
  endpoints: (build) => ({
    saveCriteria: build.mutation<any, any>({
      query: (body) => ({
        method: 'POST',
        url: '/v1/criteria_groups',
        body: {
          criteria_group: body,
        },
      }),
    }),
    deleteCriteria: build.mutation<any, number>({
      query: (criteriaId) => ({
        method: 'DELETE',
        url: `/v1/criteria_groups/${criteriaId}`,
      }),
      invalidatesTags: (_, __, arg) => [
        { type: GLOBAL_TAG_TYPES.criteriaGroups, id: arg },
      ],
    }),
    updateCriteria: build.mutation<any, { previousCriteriaId: number, body: any }>({
      query: ({ previousCriteriaId, body }) => ({
        method: 'PUT',
        url: `/v1/criteria_groups/${previousCriteriaId}`,
        body: {
          criteria_group: body,
        },
      }),
      invalidatesTags: (_, __, arg) => [
        { type: GLOBAL_TAG_TYPES.criteriaGroups, id: arg.previousCriteriaId },
      ],
    }),
    getCriteria: build.query<any, number[]>({
      query: (criteriaGroupIds) => ({
        method: 'POST',
        url: '/graphql',
        body: {
          query: getCriteria,
          variables: {
            criteriaGroupIds,
          },
        },
      }),
      transformResponse: transformGraphqlResponse,
      providesTags: (_, __, arg) => arg.map((id) => ({ type: GLOBAL_TAG_TYPES.criteriaGroups, id })),
    }),
  }),
});

export const {
  useSaveCriteriaMutation,
  useDeleteCriteriaMutation,
  useUpdateCriteriaMutation,
  useGetCriteriaQuery,
  useLazyGetCriteriaQuery,
} = criteriaService;

export { criteriaService };
